import {bp} from '../core/namespace.js';

$.extend(true, bp, {
  image_slider: (function () {
    var current_estate = undefined;
    var image_src = undefined;
    var prev_button = undefined;
    var next_button = undefined;

    var page_estates_list = [];
    var page_estates = {};
    return {
      init_slider: function (estateofferId) {
        if (page_estates_list.includes(estateofferId)) {
          current_estate = page_estates[estateofferId];
        } else {
          $.ajax({
            dataType: 'json',
            data: {'pk': estateofferId},
            url: '/zoeken/list/ajax/imageslider/',
            cache: false,
            async: true,
            success: function (result) {
              current_estate = {
                pk: estateofferId,
                url: result.data[1],
                index: 1,
                photo_urls: result.data,
                photo_thumbs: result.thumbs,
                num_of_photos: result.count,
              };

              page_estates[estateofferId] = current_estate;
              page_estates_list.push(estateofferId);

              bp.image_slider.swapSlide(+1);
            },
          });
        }
      },
      swapSlide: function (n) {
        current_estate.index = current_estate.index + n;
        current_estate.url = current_estate.photo_urls[current_estate.index];
        current_estate.srcset = current_estate.photo_thumbs[current_estate.index];
        page_estates[current_estate.pk] = current_estate;

        image_src = $('#' + current_estate.pk);
        image_src.attr('src', current_estate.url);
        image_src.attr('srcset', current_estate.srcset);

        if (current_estate.index > 1) {
          prev_button.style.display = 'block';
        } else {
          prev_button.style.display = 'none';
        }

        if (current_estate.index === current_estate.num_of_photos) {
          next_button.style.display = 'none';
        } else {
          next_button.style.display = 'block';
        }
      },
      nextImage: function (e, estateofferId) {
        e.stopPropagation();
        var target = event.target ? event.target : event.srcElement;

        if (current_estate === undefined || current_estate.pk !== estateofferId) {
          prev_button = target.previousElementSibling;
          next_button = target;
          bp.image_slider.init_slider(estateofferId);
        } else {
          bp.image_slider.swapSlide(+1);
        }
        target.blur();
        return false;
      },
      prevImage: function (e, estateofferId) {
        e.stopPropagation();
        var target = event.target ? event.target : event.srcElement;
        if (current_estate.pk !== estateofferId) {
          current_estate = page_estates[estateofferId];
          prev_button = target;
          next_button = target.nextElementSibling;
        }

        bp.image_slider.swapSlide(-1);
        target.blur();
        return false;
      },
    };
  })(),
});

export {bp};
